import '../styles/CTA.css';
import { useEffect, useState } from 'react';
import { FaPen } from 'react-icons/fa';
import { useCTAContent, DEFAULT_CTA_CONTENT } from '../../ViewModel/CTAViewModel.js';
import { sanitizeNavigationHref } from '../../Model/Services/urlSafetyService.js';

function CTA({ adminMode = false }) {
    const { content, loading, error, saving, saveContent } = useCTAContent();
    const cta = content || DEFAULT_CTA_CONTENT;
    const [form, setForm] = useState(cta);
    const [message, setMessage] = useState('');
    const [editing, setEditing] = useState(false);

    useEffect(() => {
        setForm(cta);
    }, [cta]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        setMessage('');
        try {
            await saveContent(form);
            setMessage('Sparat.');
            setEditing(false);
        } catch (err) {
            setMessage(`Fel: ${err.message}`);
        }
    };

    const renderView = () => (
        <div className="cta-card">
            <div className="cta-left">
                <div className="cta-headline-row">
                    <h1>{cta.headline1}</h1>
                    {adminMode && (
                        <button className="cta-pen" aria-label="Redigera CTA" onClick={() => setEditing(true)}>
                            <FaPen />
                        </button>
                    )}
                </div>
                <h1 id='headline2'>{cta.headline2}</h1>
            </div>
            <div className="cta-right">
                <p>{cta.body}</p>
                <a className="cta-button" href={sanitizeNavigationHref(cta.buttonHref, '#kontakt')}>{cta.buttonText}</a>
            </div>
        </div>
    );

    const renderEdit = () => (
        <div className="cta-card cta-edit-card">
            <div className="cta-edit-grid">
                <label>
                    Rubrik 1
                    <input name="headline1" value={form.headline1} onChange={handleChange} />
                </label>
                <label>
                    Rubrik 2
                    <input name="headline2" value={form.headline2} onChange={handleChange} />
                </label>
            </div>
            <label>
                Brödtext
                <textarea name="body" value={form.body} onChange={handleChange} rows={3} />
            </label>
            <div className="cta-edit-grid">
                <label>
                    Knapptext
                    <input name="buttonText" value={form.buttonText} onChange={handleChange} />
                </label>
                <label>
                    Knapp-länk
                    <input name="buttonHref" value={form.buttonHref} onChange={handleChange} />
                </label>
            </div>
            <div className="cta-edit-actions">
                <button className="cta-ghost" onClick={() => setEditing(false)}>Avbryt</button>
                <button className="cta-primary" onClick={handleSave} disabled={saving}>{saving ? 'Sparar...' : 'Spara'}</button>
                {message && <span className="cta-message">{message}</span>}
            </div>
        </div>
    );

    return (
        <div className="cta-container">
            {adminMode && editing ? renderEdit() : renderView()}
            {error && <p className="cta-error">{error}</p>}
            {loading && !content && <p className="cta-loading">Laddar...</p>}
        </div>
    );
}

export default CTA;
